import React from 'react';
import { CompendiumEntityIcon } from 'src/images';
import styles from '../knowledge/knowledge-item-row.module.scss';
import { formatFullName } from 'shared/utils';
import { useSelector } from 'react-redux';
import { getOwnersByIDs } from 'shared/store/selectors/owners.selector';
import { getLang } from 'shared/store/selectors/lang.selector';
import classNames from 'classnames';
import { RenderLabels } from 'src/components/common/categories/components';

const LabItemRow = ({ item, onSelect, disabled = false, selected = false, isHidden = false }) => {
  const { title, subtitle, ownerIds, labels } = item;
  const owners = useSelector(getOwnersByIDs(ownerIds));
  const lang = useSelector(getLang('CONTENT_SELECTOR'));

  return (
    <button
      type="button"
      className={classNames([
        'new-design-system',
        styles.container,
        disabled && styles.disabled,
        selected && styles.selected,
        isHidden && styles.hide,
      ])}
      onClick={() => onSelect(item)}
      disabled={disabled}
      role="option"
      aria-selected={selected}
    >
      <div className={styles.item}>
        <div className={styles.itemContent}>
          <img src={CompendiumEntityIcon} className={styles.itemIcon} alt={'lab-item'} />
          <div className={styles.textContainer}>
            <p className={styles.title}>{title}</p>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            <div className={styles.footer}>
              {owners.length > 0 && (
                <span>
                  {lang.OWNED_BY}{' '}
                  <strong>{owners.map(owner => formatFullName(owner)).join(', ')}</strong>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {labels && <RenderLabels labels={labels} styles={styles} />}
    </button>
  );
};

export { LabItemRow };
